import React from 'react'
import { BooleanInput } from 'react-admin'
import { KFilterFieldProps } from 'ui-shared/KFilters'
import { useFormContext } from 'react-hook-form'
import { FILTER_SOURCES } from 'services/cfg/filter'

export const TailoredVisibleToAllFilter: React.FC<KFilterFieldProps> = ({
  source,
  label,
}) => {
  const { setValue } = useFormContext()

  // this function is used to delete the client and organization tailored selection
  // when the checkbox is selected
  const resetClientAndOrganizationFilter = () => {
    setValue(FILTER_SOURCES.customerId, '')
    setValue(FILTER_SOURCES.organizationId, '')
  }

  return (
    <BooleanInput
      source={source}
      label={label}
      parse={(e) => (e ? true : '')}
      format={(e) => !!e}
      defaultValue={true}
      onChange={resetClientAndOrganizationFilter}
    />
  )
}
